import React from "react";
import { useAuth } from "../context/useAuthContext";

const Footer = () => {
  const { auth } = useAuth();

  // console.log("auth:", auth);

  return (
    <>
      {/* Footer */}
      <div
        className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3 py-2 bg-dark"
        style={{ fontSize: "0.78rem" }}
      >
        <div>
          <div className="d-flex align-items-center justify-content-center gap-3 mb-1">
            <div className="text-capitalize">
              User Name: {auth?.full_name ?? ""}{" "}
            </div>
            {/* <div className="vr my-auto" style={{ height: 10 }}></div> */}
            {/* <div>AccountId: 272337</div> */}
            <div
              className="vr my-auto d-none d-md-block"
              style={{ height: 10 }}
            ></div>
            <div className="d-none d-md-block">
              Last Login: May 30, 2026, 1:58:38 PM
            </div>
          </div>
          {/* ---- mobile ---- */}
          <div className="text-center d-md-none mb-2">
            Last Login: May 30, 2026, 1:58:38 PM
          </div>
          {/* ---- /mobile ---- */}
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-md-center gap-md-3">
            {/* <div>Policies: Privacy Policy & EU/GDPR Privacy Policy</div> */}
            {/* <div
              className="vr my-auto d-none d-md-block"
              style={{ height: 10 }}
            ></div> */}
            <div>
              Copyright © - {new Date().getFullYear()} Aupertz All rights
              reserved.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;

{
  /* Footer */
}
// <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
//   <p className="mb-0">© 2026 Aupertz. All rights reserved.</p>
// </div>
